import api from '../../../../../utils/api'
import Utils from '../../../../../utils/utils'

export const getSubmitDepositType = async (): Promise<'ftd' | 'recurring' | 'na'> => {
    try {
        const res = await api.getTransactions()
        if (!Utils.validResponse(res)) return 'na'
        const priorSuccessful = res.payload[0].result.filter((x: any) => x.type === 'DEPOSIT' && ['APPLIED', 'APPROVED'].includes(x.status))
        return priorSuccessful.length === 0 ? 'ftd' : 'recurring'
    } catch { return 'na' }
}
